import { TextField, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import { useTheme } from '@mui/styles';
import { appInsights } from '../../../auth/appInsight';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const SearchFiled = styled(TextField)(({ theme, height, background }) => ({
  border: `2px solid ${theme.palette.border.containerborder}`,
  fontFamily: 'Poppins',
  justifyContent: 'center',
  width: '100%',
  height: height || '',
  padding: '0px',
  borderRadius: '8.0859px',
  background: background || theme.palette.background.default,
  '&:focused': {
    boxShadow: `1px 1px 1px ${theme.palette.primary.lightblack}`
  },
  '& .MuiOutlinedInput-root': {
    '& > fieldset': {
      border: 'none'
    }
  },
  
  [theme.breakpoints.up('xll')]: {
    borderRadius: getStringProduct(1.25, '8.0859px'),
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.25, height) || '',
    padding: getStringProduct(1.25, '5px 14px')
  },
  [theme.breakpoints.up('xlll')]: {
    borderRadius: getStringProduct(1.66, '8.0859px'),
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.66, height) || '',
    padding: getStringProduct(1.66, '5px 14px')
  },
  [theme.breakpoints.up('xl4')]: {
    borderRadius: getStringProduct(2.46, '8.0859px'),
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(2.46, height) || '',
    padding: getStringProduct(2.46, '5px 14px')
  },
}));

const FreedomSearchField = (props) => {
  const theme = useTheme();
  const xlll = useMediaQuery(theme.breakpoints.up('xlll'));
  const xll = useMediaQuery(theme.breakpoints.up('xll'));
  const xl4 = useMediaQuery(theme.breakpoints.up('xl4'));
  const { placeholder = 'Search', background='' } = props;
  try {
    return (
      <SearchFiled
        fullWidth
        background={background}
        inputProps={{
          style: {
            fontFamily: 'Poppins',
            fontStyle: 'normal',
            fontWeight: '400',
            padding: xl4 ? getStringProduct(2.46, '4px 0px 5px') : xlll ? getStringProduct(1.66, '4px 0px 5px') : xll ? getStringProduct(1.25, '4px 0px 5px') : '5px 14px',
            fontSize: xl4 ? getStringProduct(2.46, '15px') : xlll ? getStringProduct(1.66, '15px') : xll ? getStringProduct(1.25, '15px') : '15px',
            lineHeight: xl4 ? getStringProduct(2.46, '21px') : xll ? getStringProduct(1.66, '21px') : xll ? getStringProduct(1.25, '21px') : '21px'
          }
        }}
        placeholder={placeholder}
        {...props}
      />
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomSearchField;
